import {Button, Modal, Typography} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import React from 'react'

import {Validator} from '../Validator'
import {VerticalTimeline} from '../VerticalTimeline'
import type {TimelineDetailsModalProps} from './types'

const classes = {
  paper: css`
    inline-size: 480px;
    max-block-size: 80vh;
    overflow: hidden;
    border-radius: 24px;
    padding: 16px;
    background: var(--colorScheme-background, #fff);
    box-shadow: 0 5px 40px rgb(0 0 0 / 25%);
    border: 1px solid var(--colorScheme-line, #d2d0cc);
  `,

  scrollContainer: css`
    max-block-size: calc(80vh - 32px);
    overflow-y: auto;
    margin: -16px;
    padding: 16px;
  `,

  header: css`
    padding-block-end: 8px;
  `,

  title: css`
    font-size: 24px;
    font-weight: 700;
    line-height: 27px;
    color: var(--colorScheme-text, #21201f);
  `,

  validator: css`
    padding-block-start: 8px;
    padding-block-end: 8px;
  `,

  content: css`
    padding-block-start: 8px;
    padding-block-end: 16px;
  `,

  footer: css`
    display: flex;
    gap: 4px;
    padding-block-start: 16px;
  `,

  button: css`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    min-block-size: 56px;
  `,
}

export const ModalDesktopAuth: React.FC<TimelineDetailsModalProps> = ({action, onClose}) => {
  const handleShare = () => {
    if (action.share_button?.action && action.share_button.action.type === 'share') {
      const shareAction = action.share_button.action
      if ('sharing_url' in shareAction) {
        if (navigator.share) {
          navigator
            .share({
              title: shareAction.title || '',
              url: shareAction.sharing_url,
            })
            .catch(() => {
              // Игнорируем ошибки (пользователь отменил шаринг)
            })
        }
      }
    }
  }

  return (
    <Modal className={classes.paper} onClose={onClose} opened>
      <div className={classes.scrollContainer}>
        <div className={classes.header}>
          <div className={classes.title}>{action.title}</div>

          {action.bubble && (
            <div className={classes.validator}>
              <Validator bubble={action.bubble} currentPointIndex={0} pointCount={0} />
            </div>
          )}
        </div>

        <div className={classes.content}>
          <VerticalTimeline action={action} />
        </div>

        <div className={classes.footer}>
          {action.share_button && (
            <Button className={classes.button} onPress={handleShare} size="l" variant="default">
              <Typography variant="body2">{action.share_button.text}</Typography>
            </Button>
          )}
          <Button className={classes.button} onPress={onClose} size="l" variant="action">
            <Typography thickness="medium" variant="body2">
              {action.done_button.text}
            </Typography>
          </Button>
        </div>
      </div>
    </Modal>
  )
}
